<template>
  <div class="input" :class="{ required_class: required }">
    <label>{{ title }}</label>
    <input
      :required="required"
      :placeholder="placeholder"
      :value="modelValue"
      :type="type"
      @input="updateInput"
    />
  </div>
</template>

<script>
export default {
  name: "form-input",
  props: {
    modelValue: [String, Number],
    required: {
      type: Boolean,
      default: () => false,
    },
    title: {
      type: String,
      default: () => "",
    },
    type: {
      type: String,
      default: () => "",
    },
    placeholder: {
      type: String,
      default: () => "",
    },
  },
  methods: {
    updateInput(event) {
      this.$emit("update:modelValue", event.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  font-family: UAF Sans;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  color: #fff;
}

input {
  border: 1px solid #1c1c1c;
  color: white;
  background: #fff;
  height: 79px;
  margin: 10px 0;
  width: 100%;
  padding: 30px;
  font-family: "HalvarR";
  box-sizing: border-box;
  font-family: UAF Sans;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  color: #000;

  @media only screen and (max-width: 767px) {
    width: 100%;
  }
}
</style>
